<template>
  <v-container>
    <v-row class="text-center my-5">
      <v-col class="mb-5" cols="12">
        <component :is="componentFromPath" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import InstancesCard from "./Categories/InstancesCard.vue";
import PlansCard from "./Categories/PlansCard.vue";
import TenantsCard from "./Categories/TenantsCard.vue";
import SubscriptionsCard from "./Categories/SubscriptionsCard.vue";
import LedgerCard from "./Categories/LedgerCard.vue";
import InvoicesCard from "./Categories/InvoicesCard.vue";
import QuotasCard from "./Categories/QuotasCard.vue";
import QuotaAggregate from "./Aggregates/QuotaAggregate.vue";
import LedgerAggregate from "./Aggregates/LedgerAggregate.vue";

export default {
  components: {
    InstancesCard,
    PlansCard,
    TenantsCard,
    SubscriptionsCard,
    LedgerCard,
    InvoicesCard,
    QuotasCard,
    QuotaAggregate,
    LedgerAggregate,
  },

  data: () => ({
    componentMap: {
      instances: "InstancesCard",
      plans: "PlansCard",
      tenants: "TenantsCard",
      subscriptions: "SubscriptionsCard",
      ledger: "LedgerCard",
      invoices: "InvoicesCard",
      quotas: "QuotasCard",
      information: "QuotaInformationCard",
      aggregate: "QuotaAggregate",
      analysis: "LedgerAggregate",
    },
  }),

  computed: {
    componentFromPath() {
      return this.componentMap[this.$route.params.category];
    },
  },

  beforeMount() {
    if (!Object.keys(this.componentMap).includes(this.$route.params.category))
      this.$router.push("/");
  },
};
</script>
